module.exports = __webpack_public_path__ + "img/ic_life_market.d1c7a2a8.png";